export default "__VITE_PUBLIC_ASSET__18dae70c__"